import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import VENDOR_LOGO from 'src/assets/logoVendor.svg';
import palette from 'src/constants/palette';
import DownloadVendorAppCard from './components/DownloadVendorAppCard';
import VendorHelpLink from './components/VendorHelpLink';

const PREFIX = 'VendorLinkInvalid';

const classes = {
    root: `${PREFIX}-root`,
    logoWrap: `${PREFIX}-logoWrap`,
    messageWrap: `${PREFIX}-messageWrap`,
};

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        backgroundColor: palette.vendorBackdrop,
        width: '100%',
        height: '100%',
        padding: theme.spacing(6, 0),
        minHeight: '100vh',
    },

    [`& .${classes.logoWrap}`]: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: theme.spacing(2),
    },

    [`& .${classes.messageWrap}`]: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(6, 0, 4),
    },
}));

const VendorLinkInvalid = () => {
    const { t } = useTranslation('vendor.index');
    return (
        <Root className={classes.root}>
            <VendorHelpLink size="xs" />
            <Container maxWidth="xs">
                <div className={classes.logoWrap}>
                    <img src={VENDOR_LOGO} alt={t('logoAlt')} />
                </div>
                <div className={classes.messageWrap}>
                    <Typography variant="h2">{t('invalidLink')}</Typography>
                </div>
                <DownloadVendorAppCard />
            </Container>
        </Root>
    );
};

export default VendorLinkInvalid;
